import { useState } from "react"
import moment from "moment";
import { Avatar, Button, Skeleton, Typography } from "../../../../../components/common"
import { ImageTypes, mimeTypes, truncateString } from "../../../../../utils/common";
import { generateBGColorClassName } from "../../../../../utils/randomColor";

const SingleComments = (props) => {
    const { body_text = '', created_at = '', attachments = [], user_details = {}, index = 0 } = props || { body_text: '', created_at: '', attachments: [], user_details: {} };
    const [isExpand, setExpand] = useState(false);

    const PDFFile = ({ name, attachment_url, content_type }) => {
        return (
            <a href={attachment_url} download  >
                <div role="button" className='flex items-center p-1 px-2 bg-primary-50 hover:bg-primary-100 w-fit rounded-sm'>
                    {ImageTypes?.[mimeTypes?.[content_type]]}
                    <Typography className="text-secondary-600 font-semibold text-[14px] " text={truncateString(name, 12)} />
                </div>
            </a>
        )
    }

    return (<div className='flex w-full gap-2 my-3 items-start'>
        <Avatar type="text" alt={user_details?.name || 'Support Agent'} className={`${generateBGColorClassName(index)} !h-9 !w-9 mb-auto cursor-pointer`} />
        <div className='flex flex-col gap-2 w-1/9'>
            <div>
                <Typography variant="sm" className="font-semibold capitalize" text={user_details?.name || 'Support Agent'} />
                <Typography className="font-thin text-secondary-400 text-[14px]" text={`${moment(created_at).format("DD MMM YYYY, hh:mm A")}`} />
            </div>
            <Typography className="text-secondary-500 w-1/9 font-normal text-[14px]" text={body_text || '_'} />
            <div className='flex flex-col gap-1'>
                {!!attachments?.length &&
                    attachments?.slice(0, 1)?.map(file =>
                        <div key={file?.title} className='flex items-center gap-1'>
                            <PDFFile {...file} />
                            {!isExpand && attachments?.length > 1 && <Button variant="tertiary" onClick={() => setExpand(!isExpand)} className="h-fit" text="+4 more" />}
                        </div>)}
                {isExpand && <>
                    {!!attachments?.length &&
                        attachments?.slice(1, attachments?.length)?.map(file => <PDFFile key={file?.id}  {...file} />)}
                </>}
            </div>
        </div>
    </div>)
}

export const CommentLists = (props) => {
    const { viewGreyTHRTicket = {}, loading = false } = props || { viewGreyTHRTicket: {}, loading: false }
    const { conversations = [] } = viewGreyTHRTicket || { conversations: [] }

    return (<div className=' py-4'>
        <Typography variant="lg" className="font-semibold" text={"Comments"} />
        <div className="max-h-[50vh] overflow-y-auto">
            {loading ?
                Array.from({ length: 3 }, (_, i) => i + 1)?.map(loader => < Loader key={loader} />) :
                !!conversations?.length ? conversations?.map((conversation, index) =>
                    <SingleComments loading={loading} {...conversation} index={index} />) : (
                    <div className="my-4">
                        <Typography variant="sm" className="font-thin" text={"No Comments found"} />
                    </div>
                )}
        </div>
    </div>)
}

const Loader = () => (<div className='flex w-full gap-2 my-3'>
    <Skeleton className="h-[36px] w-[36px] min-w-[36px]  rounded-full " parentClassName="w-fit" length={1} />
    <div className='flex flex-col gap-2 w-1/9'>
        <div className="w-1/9 flex flex-col gap-1">
            <Skeleton length={1} className="w-full h-6" />
            <Skeleton length={1} className="w-full h-3" />
        </div>
        <Skeleton length={5} className="h-3 w-full rounded-sm gap-1 my-1" />
        <div className='flex flex-col gap-1'>
            <div className='flex items-center gap-1'>
                <Skeleton length={1} className="w-1/2 h-3" />
            </div>
        </div>
    </div>
</div>)